import { render } from "./ToolBox.vue?vue&type=template&id=0c9c2490&scoped=true"
import script from "./ToolBox.vue?vue&type=script&lang=js"
export * from "./ToolBox.vue?vue&type=script&lang=js"

import "./ToolBox.vue?vue&type=style&index=0&id=0c9c2490&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9c2490"]])

export default __exports__